// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as PeriodicWave$WebAudio from "./PeriodicWave.bs.js";

var createAudioContext = (function () {
       var AudioContext = window.AudioContext || window.webkitAudioContext;
       return new AudioContext();
     });

function makePeriodicWave(samples, audioContext) {
  var match = PeriodicWave$WebAudio.calculateCoefficients(samples);
  return audioContext.createPeriodicWave(match[0], match[1], {
              disableNormalization: false
            });
}

export {
  createAudioContext ,
  makePeriodicWave ,
  
}
/* No side effect */
